import React from "react";
import { List } from "antd";
import { DateHelper } from "../../../../helper";
import { DateFormat, RegExp } from "../../../../constants";
import { getApprovalStatusText } from "../../Utils/approvalStatus";

const ListComponent = ({ dataSource }: { dataSource: any[] }) => {
  const translations: any = {
    eApprovedBy: "Thủ trưởng CQ/ĐV",
    eApprovedStatus: "Trạng thái thủ trưởng",
    eApprovedDate: "Ngày thủ trưởng phê duyệt",
    eDeptHeadComment: "Chú ý của Thủ trưởng CQ/ĐV",
    eApprovedByITLead: "Người duyệt bước 2",
    eApprovedByITLeadStatus: "Trạng thái phê duyệt bước 2",
    eApprovedByITLeadDate: "Ngày bước 2 phê duyệt",
    eITLeadComment: "Chú ý của người duyệt bước 2",
    eApprovedByITHead: "Người duyệt bước 3",
    eApprovedByITHeadStatus: "Trạng thái phê duyệt bước 3",
    eApprovedByITHeadDate: "Ngày bước 3 phê duyệt",
    eITHeadComment: "Chú ý của người duyệt bước 3",
    eAssignee: "Hoàn tất/Nghiệm thu",
    eAssigneeStatus: "Trạng thái nghiệm thu",
    eAssigneeStatusDate: "Ngày toàn tất nghiệm thu",
    eAssigneeComment: "Chú ý của người nghiệm thu",
    ePins: "Phiếu này được ghim ở",
    Approved: "Đã phê duyệt",
    Completed: "Đã hoàn tất",
    eDepartment: "CQ/ĐV",
    eUnit: "Đơn vị thuộc cơ quan",
    eDescription: "Mô tả",
    eRequestStatus: "Tình trạng phiếu",
    eCreatedDate: "Ngày tạo",
    eCause: "Lý do",
    eRequestType: "Loại yêu cầu",
  };

  const listItemContent = (value: any) => {
    try {
      const jsonArray = JSON.parse(value);
      if (Array.isArray(jsonArray)) return jsonArray.map((e: any) => <p style={{ flex: 2 }}>{e.type === "reject" ? `từ chối với lý do: ${e.value} (${e.date})` : `đồng ý với lý do: ${e.value} (${e.date})`}</p>);
      return <p style={{ flex: 2 }}>{`${getApprovalStatusText(value)}`}</p>;
    } catch (error) {

      const isIsoDate = (input: string): boolean => {
        return RegExp.iso8601Regex.test(input);
      };

      if (isIsoDate(value)) {
        return <p style={{ flex: 2 }}>{`${DateHelper.formatDateToString(value, {format: DateFormat.DD_MM_YYYY_HH_MM})}`}</p>
      } else {
        return <p style={{ flex: 2 }}>{`${getApprovalStatusText(value)}`}</p>;
      }
    }
    
  };

  return (
    <List
      itemLayout="horizontal"
      dataSource={dataSource}
      style={{}}
      header={
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <p style={{ flex: 1, color: "rgb(36 199 146)", fontSize: "14px", fontWeight: 400 }}>Phiên bản</p>
          <p style={{ flex: 5, color: "rgb(36 199 146)", fontSize: "14px", fontWeight: 400 }}>Nội dung sửa đổi</p>
          <p style={{ flex: 2, color: "rgb(36 199 146)", fontSize: "14px", fontWeight: 400 }}>Sửa đổi bởi</p>
        </div>
      }
      renderItem={(item) => {
        const { version, modifier, title, eUpdateHistory, eComments, ePassportContent, ePins, ...object } = item;
        return (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "start" }}>
            <p style={{ flex: 1, fontWeight: "bold" }}>{item.version}</p>
            <div style={{ flex: 5, marginBottom: "5px" }}>
              <p style={{ fontWeight: "bold" }}>
                {DateHelper.formatDateToString(item.modifier.date, { format: DateFormat.DD_MM_YYYY_HH_MM })}
              </p>
              <div style={{ marginTop: "10px" }}>
                <p style={{ marginBottom: "10px" }}>{item.title}</p>
                {Object.entries(object).map(([key, value], index: number) => (
                  <div className="d-flex row" style={{ margin: 0 }}>
                    <p key={key} style={{ flex: 1 }}>{`${translations[key] || key}`}</p>
                    {listItemContent(value)}
                  </div>
                ))}
              </div>
            </div>
            <p style={{ flex: 2, fontWeight: "bold" }}>{item.modifier.displayName}</p>
          </div>
        );
      }}
    />
  );
};

export default ListComponent;
